import _regeneratorRuntime from "/codebuild/output/src1688139503/src/cocoo_school_admin/node_modules/@babel/runtime/helpers/esm/regeneratorRuntime.js";
import _asyncToGenerator from "/codebuild/output/src1688139503/src/cocoo_school_admin/node_modules/@babel/runtime/helpers/esm/asyncToGenerator.js";
import "core-js/modules/es.array.filter.js";
import "core-js/modules/es.object.to-string.js";
import "core-js/modules/es.array.concat.js";
import "core-js/modules/web.dom-collections.for-each.js";
import "core-js/modules/es.array.push.js";
import "core-js/modules/es.map.js";
import "core-js/modules/es.object.keys.js";
import "core-js/modules/es.set.js";
import "core-js/modules/web.dom-exception.constructor.js";
import "core-js/modules/web.dom-exception.stack.js";
import "core-js/modules/web.dom-exception.to-string-tag.js";
import "core-js/modules/web.structured-clone.js";
import "core-js/modules/es.array.find.js";
var __default__ = {
  methods: {
    init: function init() {
      return;
    },
    handleClassroomChange: function handleClassroomChange() {
      return;
    },
    handleGroupChange: function handleGroupChange() {
      return;
    }
  }
};
import moment from "moment";
import { getData } from "@/services/axios";
import CalendarHeading from "./CalendarHeading.vue";
import GroupClassSelectForm from "./GroupClassSelectForm.vue";
import MonthlyClassTable from "@/components/dekitus/monthly/MonthlyClassTable.vue";
import AttendanceTemperatureSwitch from "@/components/attendances/monthly/AttendanceTemperatureSwitch.vue";
import DekitusIntroduction from "@/components/common/DekitusIntroduction";

import { storeToRefs } from 'pinia';
import { useLoadingStore } from '/codebuild/output/src1688139503/src/cocoo_school_admin/src/stores/loading.js';
import { useGradeClassroomStore } from '/codebuild/output/src1688139503/src/cocoo_school_admin/src/stores/gradeClassroom.js';
import { useSchoolPlanStore } from '/codebuild/output/src1688139503/src/cocoo_school_admin/src/stores/schoolPlan.js';
import { useMonthlySummary } from '/codebuild/output/src1688139503/src/cocoo_school_admin/src/composables/monthlySummary.js';
import { watch, ref } from 'vue';
export default /*#__PURE__*/Object.assign(__default__, {
  __name: 'MonthlyDekitus',
  setup: function setup(__props) {
    // @ts-check
    var _storeToRefs = storeToRefs(useLoadingStore()),
        isLoading = _storeToRefs.isLoading;

    var _storeToRefs2 = storeToRefs(useGradeClassroomStore()),
        classrooms = _storeToRefs2.classrooms;

    var _storeToRefs3 = storeToRefs(useSchoolPlanStore()),
        schoolPlan = _storeToRefs3.schoolPlan;

    var _useMonthlySummary = useMonthlySummary(),
        filter = _useMonthlySummary.filter,
        monthData = _useMonthlySummary.monthData;

    watch(filter, function () {
      setData();
    }, {
      deep: true
    });
    var displayLabel = ref("book");
    /** @type Ref<Object<number, MonthData[]>> */

    var classMonthData = ref({});
    var dailyEvents = ref({});
    /** @type typeof classrooms */

    var visibleClassroom = ref([]);
    /** @type Ref<Object<number, any>> */

    var selectClassStudentAttendaceObject = ref({});
    var dekitusIds = ref([]);

    var setData = /*#__PURE__*/function () {
      var _ref = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime().mark(function _callee() {
        var date, data, classroom;
        return _regeneratorRuntime().wrap(function _callee$(_context) {
          while (1) {
            switch (_context.prev = _context.next) {
              case 0:
                isLoading.value = true;
                date = moment(filter.value.yearMonth);
                _context.next = 4;
                return getData(["reader/get_students_with_attendance?dekitus=1&year_month=".concat(date.format("YYYY-MM"), "&classroom_id=").concat(filter.value.classroomId, "&group_id=").concat(filter.value.groupId), "events?orderby=updated_at&order=asc&classroom_id=" + filter.value.classroomId + "&year_month=" + filter.value.yearMonth, "dekitus_id_stocks"]).catch(function (error) {
                  console.log(error);
                });

              case 4:
                data = _context.sent;
                // 表示するクラスを整理する
                selectClassStudentAttendaceObject.value = data[0].items;
                visibleClassroom.value = [];
                classMonthData.value = {};
                dailyEvents.value = {};

                if (filter.value.classroomId === 0) {
                  // 全てのクラスを選択したとき
                  classrooms.value.forEach(function (v) {
                    if (selectClassStudentAttendaceObject.value[v.id]) {
                      visibleClassroom.value.push(v);
                      classMonthData.value[v.id] = structuredClone(monthData.value);
                      dailyEvents.value[v.id] = {};
                    }
                  });
                } else {
                  // 個別のクラスを選択したとき
                  classroom = classrooms.value.find(function (v) {
                    return v.id === filter.value.classroomId;
                  });
                  visibleClassroom.value.push(classroom);
                  classMonthData.value[classroom.id] = structuredClone(monthData.value);
                  dailyEvents.value[classroom.id] = {};
                }

                data[1].items.forEach(function (v) {
                  // 月をまたぐ際は今月の範囲内に限定する
                  var from = date.isSame(v.from, "month") ? moment(v.from) : date.clone().startOf("month");
                  var to = date.isSame(v.to, "month") ? moment(v.to) : date.clone().endOf("month");

                  while (from.isSameOrBefore(to, "day")) {
                    v.classroom.forEach(function (w) {
                      if (dailyEvents.value[w.classroom_id]) {
                        var key = from.format("YYYY-MM-DD");

                        if (dailyEvents.value[w.classroom_id][key]) {
                          dailyEvents.value[w.classroom_id][key].push(v);
                        } else {
                          dailyEvents.value[w.classroom_id][key] = [v];
                        }

                        classMonthData.value[w.classroom_id][from.date() - 1].isSchoolDayOff = Boolean(v.is_school_day_off);
                      }
                    });
                    from.add(1, "day");
                  }
                });
                dekitusIds.value = data[2].items[0] && data[2].items[0].dekitus_ids ? data[2].items[0].dekitus_ids : [];
                isLoading.value = false;

              case 13:
              case "end":
                return _context.stop();
            }
          }
        }, _callee);
      }));

      return function setData() {
        return _ref.apply(this, arguments);
      };
    }(); // created


    setData();
    return {
      __sfc: true,
      isLoading: isLoading,
      classrooms: classrooms,
      schoolPlan: schoolPlan,
      filter: filter,
      monthData: monthData,
      displayLabel: displayLabel,
      classMonthData: classMonthData,
      dailyEvents: dailyEvents,
      visibleClassroom: visibleClassroom,
      selectClassStudentAttendaceObject: selectClassStudentAttendaceObject,
      dekitusIds: dekitusIds,
      setData: setData,
      CalendarHeading: CalendarHeading,
      GroupClassSelectForm: GroupClassSelectForm,
      MonthlyClassTable: MonthlyClassTable,
      AttendanceTemperatureSwitch: AttendanceTemperatureSwitch,
      DekitusIntroduction: DekitusIntroduction
    };
  }
});